import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import {initializeWebAnalyticsConsent} from './app/shared/web-analytics/web-analytics-consent';

function renderBootstrapError(error: unknown): void {
  const message = error instanceof Error ? `${error.name}: ${error.message}\n${error.stack ?? ''}` : String(error);
  console.error(error);

  if (typeof document === 'undefined') {
    return;
  }

  document.body.innerHTML = '';
  const pre = document.createElement('pre');
  pre.setAttribute('style', [
    'white-space: pre-wrap',
    'font: 14px/1.5 Consolas, monospace',
    'padding: 16px',
    'margin: 0',
    'color: #b00020',
    'background: #fff',
  ].join(';'));
  pre.textContent = message;
  document.body.appendChild(pre);
}

initializeWebAnalyticsConsent();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(renderBootstrapError);
